import gql from "graphql-tag";

export default gql`
  mutation AddLivestream($eventId: ID, $customerId: ID, $liveStreamInput: LiveStreamInputInput) {
    addLivestream(eventId: $eventId, customerId: $customerId, liveStreamInput: $liveStreamInput) {
      id
    }
  }
`;
